// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../../css-loader/dist/cjs.js!../../../../../../../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../../../../postcss-loader/dist/cjs.js!../../../../../../../../../../vue-loader/lib/index.js??vue-loader-options!./PDFPage.vue?vue&type=style&index=0&id=0a354fc3&prod&lang=css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../../../../../vue-style-loader/lib/addStylesClient.js")("79af2902", content, true);